import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// nodejs library to set properties for components
import PropTypes from "prop-types";

// material-ui components
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";

import styles from "assets/jss/material-dashboard-pro-react/components/buttonStyle.js";
import { Tooltip } from "@material-ui/core";
import { animations } from "helpers/animations";
import CachedIcon from "@material-ui/icons/Cached";
import { blue } from "@material-ui/core/colors";
const useStyles = makeStyles(styles);

const RegularButton = React.forwardRef((props, ref) => {
  const classes = useStyles();
  const {
    color,
    round,
    children,
    fullWidth,
    disabled,
    simple,
    size,
    block = false,
    style,
    styleTt,
    link,
    justIcon,
    className,
    muiClasses,
    tooltip = "",
    variant = "text",
    btnStyle,
    loading = false,
    ...rest
  } = props;
  const btnClasses = classNames({
    [classes.button]: true,
    [classes[size]]: size,
    "gn4-btn-transparent": color === "transparent",
    [classes[color]]: color,
    [classes.round]: round,
    [classes.fullWidth]: fullWidth,
    [classes.disabled]: disabled,
    [classes.simple]: simple,
    [classes.block]: block,
    [classes.link]: link,
    [classes.justIcon]: justIcon,
    [className]: className,
  });
  const hasLightBackground =
    color === "transparent" ||
    color === "white" ||
    simple ||
    link;
  const spinnerColor = hasLightBackground ? blue[500] : "#FFFFFF";
  return (
    <>
      {tooltip ? (
        <Tooltip
          title={tooltip}
          style={{
            zIndex: 0,
            ...styleTt,
            ...style,
          }}
        >
          <Button
            {...rest}
            ref={ref}
            classes={muiClasses}
            className={btnClasses}
            variant={variant}
            disabled={loading}
            style={btnStyle}
          >
            {loading && (
              <CachedIcon
                className={animations.rotate}
                style={{
                  animationIterationCount: "infinite",
                  color: spinnerColor,
                }}
              />
            )}
            <span style={loading ? { display: "none" } : {}}>{children}</span>
          </Button>
        </Tooltip>
      ) : (
        <Button
          {...rest}
          ref={ref}
          classes={muiClasses}
          className={btnClasses}
          variant={variant}
          disabled={loading}
          style={{
            ...btnStyle,
            ...style,
          }}
        >
          {loading && (
            <CachedIcon
              className={animations.rotate}
              style={{
                animationIterationCount: "infinite",
                color: spinnerColor,
              }}
            />
          )}
          <span style={loading ? { display: "none" } : {}}>{children}</span>
        </Button>
      )}
    </>
  );
});

RegularButton.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "info",
    "error",
    "success",
    "warning",
    "danger",
    "rose",
    "white",
    "twitter",
    "facebook",
    "google",
    "linkedin",
    "pinterest",
    "youtube",
    "tumblr",
    "github",
    "behance",
    "dribbble",
    "reddit",
    "transparent",
  ]),
  size: PropTypes.oneOf(["sm", "lg"]),
  simple: PropTypes.bool,
  round: PropTypes.bool,
  fullWidth: PropTypes.bool,
  disabled: PropTypes.bool,
  block: PropTypes.bool,
  link: PropTypes.bool,
  justIcon: PropTypes.bool,
  className: PropTypes.string,
  muiClasses: PropTypes.object,
  children: PropTypes.node,
  variant: PropTypes.string,
};

export default RegularButton;
